module.exports = __webpack_public_path__ + "static/media/homewise-for-realtors.0de71f70.png";